import { datadogLogs } from "@datadog/browser-logs";
import { applyPreSendLogModifications } from "@ecologi/shared";

const LOG_SAMPLE_RATE =
  (parseInt(process.env.NEXT_PUBLIC_DATADOG_SAMPLE_RATE) || 100) / 100;

export function init() {
  datadogLogs.init({
    clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
    env: process.env.NEXT_PUBLIC_DATADOG_ENV,
    forwardErrorsToLogs: true,
    service: process.env.NEXT_PUBLIC_DATADOG_SERVICE,
    site: "datadoghq.eu",
    sessionSampleRate: 100,
    telemetrySampleRate: 0,
    beforeSend: (log) => {
      // Always send error logs, regardless of sample rate
      if (log.status === "error") {
        return true;
      }

      applyPreSendLogModifications(log);

      return Math.random() < LOG_SAMPLE_RATE;
    },
  });
}
